import { Promotion } from "../../Model";
import { AdminBarberRepository } from "../../Repository";

export async function deletePromotion(
  promotionId: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.deletePromotion(promotionId);
}
